<template>
  <div :class="['app-container', { 'no-padding': noPadding }]">
    <el-form class="header-filter" v-if="!hideFilter">
      <div v-if="isSelection" :class="['filter-selection', { padding: selectionsVisible }]">
        <el-button type="primary" @click="$emit('confirmSelections', selections)">
          确认选择
        </el-button>
        <el-button @click="toggleSelctionsVisible">
          查看{{ selectionsVisible ? '所有' : '选中' }}用户
        </el-button>
      </div>
      <div class="filter-container" v-if="!selectionsVisible && isSelection">
        <div class="filter-form">
          <el-form-item v-for="(item, index) in filterMap.form" :key="index">
            <template>
              <el-input
                v-if="item.type === 'input'"
                v-model="query[item.queryKey]"
                :placeholder="item.placeholder || '输入关键字'"
                @keyup.enter.native="resetList"
              />
              <el-select
                v-else-if="item.type === 'select'"
                :multiple="!!item.multiple"
                v-model="query[item.queryKey]"
                clearable
                :placeholder="item.placeholder || '请选择'"
              >
                <el-option
                  v-for="(option, index) in item.options"
                  :key="index"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
              <el-date-picker
                v-else-if="item.type === 'daterange'"
                v-model="daterangeData[item.daterangeKey]"
                type="daterange"
                :start-placeholder="item.startPlaceholder || '开始日期'"
                :end-placeholder="item.endPlaceholder || '结束日期'"
                :value-format="item.valueFormat || 'yyyy-MM-dd'"
                @keyup.enter.native="resetList"
                @change="formatDaterange($event, item)"
              />
            </template>
          </el-form-item>
        </div>
        <div class="filter-btns">
          <el-button @click="resetList" type="primary">查询</el-button>
          <el-button
            v-for="(item, index) in filterMap.btns"
            :key="index"
            @click="item.fn"
            :loading="item.loading"
          >
            {{ item.text }}
          </el-button>
        </div>
      </div>
    </el-form>

    <div class="table-wrapper">
      <el-table
        ref="table"
        :data="list"
        v-loading="listLoading"
        @selection-change="handleSelectionChange"
        row-key="id"
        element-loading-text="加载中"
        stripe
      >
        <el-table-column
          v-if="isSelection"
          reserve-selection
          type="selection"
          width="60"
          fixed="left"
        />
        <el-table-column align="center" type="index" width="60" label="#"></el-table-column>
        <slot></slot>
      </el-table>
      <div class="pagination-container" v-if="!selectionsVisible && isSelection">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="query.current"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="listTotal"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    noPadding: {
      type: Boolean,
      default: false
    },
    hideFilter: {
      type: Boolean,
      default: false
    },
    isSelection: {
      type: Boolean,
      default: false
    },
    filterMap: {
      type: Object,
      default: () => ({
        form: [
          {
            type: 'input',
            queryKey: 'condition',
            placeholder: '输入关键字'
          }
        ],
        btns: []
      })
    },
    getListFn: {
      type: Function,
      require: true
    },
    formatList: {
      type: Function,
      require: false
    }
  },

  data() {
    return {
      list: [],
      listTotal: 0,
      listLoading: false,
      query: {
        current: 1,
        limit: 10
      },
      daterangeData: {},

      selections: [],
      selectionsVisible: false
    }
  },

  methods: {
    init(initQuery = {}) {
      Object.keys(initQuery).forEach((k) => {
        this.$set(this.query, k, initQuery[k])
      })
      this.resetList()
    },
    resetList() {
      this.query.current = 1
      this.getList()
    },
    getList() {
      this.listLoading = true
      this.getListFn(this.query).then((res) => {
        this.list = this.formatList ? this.formatList(res.result.rows) : res.result.rows
        this.listTotal = +res.result.total
        this.listLoading = false
      })
    },
    formatDaterange(timeArr, row) {
      const [beginTimeKey, endTimeKey] = row.queryKeys
      const [beginTime, endTime] = timeArr
      this.query[beginTimeKey] = `${beginTime} 00:00:00`
      this.query[endTimeKey] = `${endTime} 00:00:00`
    },
    handleCurrentChange(val) {
      this.query.current = val
      this.getList()
    },
    handleSizeChange(val) {
      this.query.limit = val
      this.resetList()
    },
    handleSelectionChange(selectedList) {
      this.selections = selectedList
      if (this.selectionsVisible) this.list = selectedList
    },
    toggleSelctionsVisible() {
      this.selectionsVisible = !this.selectionsVisible

      if (this.selectionsVisible) this.list = this.selections
      else this.resetList()
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  &.no-padding {
    padding: 0;
  }

  .header-filter {
    .filter-selection {
      padding: 20px 0 0 34px;
      width: 100%;

      &.padding {
        padding-bottom: 20px;
      }
    }

    .filter-container {
      margin-top: 0;
    }
  }
}
</style>
